import type { TitleSize } from '@tempo-io/roadmap-dto';
import type { ICard } from '@/common/components/ui/swimlane/types';
import { CARD_WIDTH, CELL_WRAPPER_PADDING, COMPACT_CARD_WIDTH } from '../../constants';

export const ITEM_TITLE_SIZE: Record<TitleSize, number> = {
  small: 12,
  medium: 14,
  large: 16,
  'extra-large': 18,
} as const;

export const getItemTitleFontSize = (labelSize: TitleSize): number => {
  return ITEM_TITLE_SIZE[labelSize];
};

export const getDateLabel = ({
  bucketLabel,
  startDate,
  endDate,
}: Pick<ICard, 'bucketLabel' | 'startDate' | 'endDate'>): string => {
  if (bucketLabel) return bucketLabel;
  if (startDate && endDate) return `${startDate} - ${endDate}`;
  return startDate || endDate || '';
};

export const getHasProgress = ({ progress }: Pick<ICard, 'progress'>): boolean =>
  typeof progress === 'number' && !Number.isNaN(progress);

export const getParentTitle = ({
  parentId,
  parentTitle,
}: Pick<ICard, 'parentId' | 'parentTitle'>): string => (parentId && parentTitle) || '';

export const getHasParentTitle = ({ parentId }: Pick<ICard, 'parentId'>): boolean =>
  Boolean(parentId);

export const getHasLabels = (
  { labels }: { labels?: ICard['labels'] },
  {
    isCompact,
    areLabelsEnabledInCompactSL,
  }: {
    isCompact: boolean;
    areLabelsEnabledInCompactSL: boolean;
  },
): boolean => {
  if (!labels?.length) {
    return false;
  }

  if (!isCompact) {
    return true;
  }

  return areLabelsEnabledInCompactSL;
};

export const getHasDescription = (
  { description }: Pick<ICard, 'description'>,
  { isItemDescriptionVisible }: { isItemDescriptionVisible: boolean },
): boolean => Boolean(isItemDescriptionVisible && description);

export const getCellWidth = (isCompact: boolean): number =>
  (isCompact ? COMPACT_CARD_WIDTH.value : CARD_WIDTH.value) + 2 * CELL_WRAPPER_PADDING.value;
